import OnPremAgentClient from '~/api/OnPremAgentClient/OnPremAgentClient'
import useOnPremAgentQuery from '~/api/onPremAgent/useOnPremAgentQuery'
import StructuredDataForm, {
  StructuredDataFormData,
} from '~/components/StructuredDataForm/StructuredDataForm'
import { JsonSchema } from '~/types/JsonSchema.interface'
import cs from './cloud_settings_form.scss'

export default function CloudSettingsForm({
  className,
  configValues,
  setConfigValues,
}: {
  className?: string
  configValues: StructuredDataFormData
  setConfigValues: (values: StructuredDataFormData) => void
}) {
  let { loading, data: schema } = useOnPremAgentQuery<null, JsonSchema | undefined>({
    backendQueryParams: {
      apiQuery: async (client: OnPremAgentClient) => client.cloud.getConfigSchema(),
      apiParams: null,
    },
  })

  const handleConfigUpdate = (key: string, newValue: unknown) => {
    if (newValue === null) {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const { [key]: _, ...configWithoutKey } = configValues ?? {}
      setConfigValues(configWithoutKey)
    } else {
      setConfigValues({ ...(configValues ?? {}), [key]: newValue })
    }
  }
  if (loading || schema == null) {
    return null
  }

  return (
    <div className={className}>
      <StructuredDataForm
        data={configValues}
        variant='wideValues'
        onEdit={handleConfigUpdate}
        dataSchema={schema}
        className={cs.structuredDataForm}
      />
    </div>
  )
}
